// services/boxService.js - Box-specific API calls
import { apiService } from './apiService';
import { API_CONFIG } from '../config/api';

export const boxService = {
  // Get all boxes
  async getBoxes() {
    return apiService.get(API_CONFIG.ENDPOINTS.BOXES);
  },

  // Get specific box details
  async getBox(boxId) {
    return apiService.get(API_CONFIG.ENDPOINTS.BOX_DETAIL(boxId));
  },

  // Get box measurements
  async getBoxMeasurements(boxId, params = {}) {
    return apiService.get(API_CONFIG.ENDPOINTS.BOX_MEASUREMENTS(boxId), params);
  },

  // Get box sensors
  async getBoxSensors(boxId) {
    return apiService.get(API_CONFIG.ENDPOINTS.SENSORS(boxId));
  },

  // Get specific sensor data
  async getSensorData(boxId, sensorId, params = {}) {
    return apiService.get(API_CONFIG.ENDPOINTS.SENSOR_DATA(boxId, sensorId), params);
  },

  // Create new box
  async createBox(boxData) {
    return apiService.post(API_CONFIG.ENDPOINTS.BOXES, boxData);
  },

  // Update box
  async updateBox(boxId, boxData) {
    return apiService.put(API_CONFIG.ENDPOINTS.BOX_DETAIL(boxId), boxData);
  },

  // Delete box
  async deleteBox(boxId) {
    return apiService.delete(API_CONFIG.ENDPOINTS.BOX_DETAIL(boxId));
  },
};